module.exports = __webpack_public_path__ + "img/card8.3523aa70.png";